var _path, _g, _path2, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntegrationCenter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -0.209505,
    y: -0.209505,
    width: 16.9112,
    height: 16.9112
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.1px)",
      clipPath: "url(#bgblur_0_11877_11135_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 2.2095,
    d: "M14.4922 8.2461C14.4922 11.6958 11.6958 14.4922 8.2461 14.4922C4.79638 14.4922 2 11.6958 2 8.2461C2 4.797 4.79638 2 8.2461 2C11.6958 2 14.4922 4.797 14.4922 8.2461Z",
    fill: "url(#paint0_linear_11877_11135)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_11877_11135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2486 8.24029C12.2486 10.4368 10.4681 12.2174 8.27154 12.2174C6.07498 12.2174 4.29443 10.4368 4.29443 8.24029C4.29443 6.04413 6.07498 4.26318 8.27154 4.26318C10.4681 4.26318 12.2486 6.04413 12.2486 8.24029Z",
    fill: "#FFBC00"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 0.198258,
    y: 0.198747,
    width: 20.9902,
    height: 20.9902
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.04px)",
      clipPath: "url(#bgblur_1_11877_11135_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 4.07909,
    d: "M10.6934 4.36279C14.19 4.36279 17.0244 7.19783 17.0244 10.6938C17.0244 14.1905 14.19 17.0249 10.6934 17.0249C7.19671 17.0249 4.3623 14.1905 4.3623 10.6938C4.36231 7.19783 7.1967 4.3628 10.6934 4.36279Z",
    fill: "#FFBC00",
    fillOpacity: 0.2,
    stroke: "url(#paint1_linear_11877_11135)",
    strokeWidth: 0.169962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 5.82508,
    y: 5.62586,
    width: 9.94798,
    height: 9.95432
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.27px)",
      clipPath: "url(#bgblur_2_11877_11135_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_11877_11135)",
    "data-figma-bg-blur-radius": 2.54943
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_11877_11135",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.21 8.54477L12.1981 11.7428C12.1606 11.8739 12.0544 11.9801 11.9233 12.0182L8.73776 13.017C8.52539 13.0863 8.31927 12.8796 8.38797 12.6672L9.38735 9.46294C9.42483 9.33178 9.53101 9.23184 9.66218 9.18812L12.8602 8.18874C13.0788 8.12003 13.2787 8.32615 13.21 8.54477Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.21 8.54477L12.1981 11.7428C12.1606 11.8739 12.0544 11.9801 11.9233 12.0182L8.73776 13.017C8.52539 13.0863 8.31927 12.8796 8.38797 12.6672L9.38735 9.46294C9.42483 9.33178 9.53101 9.23184 9.66218 9.18812L12.8602 8.18874C13.0788 8.12003 13.2787 8.32615 13.21 8.54477Z",
    fill: "url(#paint2_linear_11877_11135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1981 11.7428L12.1332 11.7223L12.1327 11.7241L12.1981 11.7428ZM11.9233 12.0182L11.9043 11.9529L11.9029 11.9534L11.9233 12.0182ZM8.73776 13.017L8.71741 12.9521L8.71666 12.9523L8.73776 13.017ZM8.38797 12.6672L8.45266 12.6881L8.45288 12.6874L8.38797 12.6672ZM9.38735 9.46294L9.45227 9.48319L9.45272 9.48162L9.38735 9.46294ZM9.66218 9.18812L9.6419 9.12321L9.64068 9.12362L9.66218 9.18812ZM12.8602 8.18874L12.8805 8.25363L12.8806 8.2536L12.8602 8.18874ZM13.21 8.54477L13.1451 8.52426L12.1333 11.7223L12.1981 11.7428L12.2629 11.7633L13.2748 8.56528L13.21 8.54477ZM12.1981 11.7428L12.1327 11.7241C12.1017 11.8326 12.0132 11.9213 11.9043 11.9529L11.9233 12.0182L11.9422 12.0835C12.0957 12.0389 12.2195 11.9152 12.2635 11.7614L12.1981 11.7428ZM11.9233 12.0182L11.9029 11.9534L8.71742 12.9521L8.73776 13.017L8.75809 13.0818L11.9436 12.0831L11.9233 12.0182ZM8.73776 13.017L8.71666 12.9523C8.55746 13.0043 8.40093 12.848 8.45266 12.6881L8.38797 12.6672L8.32329 12.6463C8.2376 12.9111 8.49332 13.1683 8.75885 13.0816L8.73776 13.017ZM8.38797 12.6672L8.45288 12.6874L9.45225 9.48319L9.38735 9.46294L9.32245 9.4427L8.32307 12.647L8.38797 12.6672ZM9.38735 9.46294L9.45272 9.48162C9.48321 9.3749 9.5708 9.29024 9.68368 9.25261L9.66218 9.18812L9.64068 9.12362C9.49122 9.17344 9.36644 9.28865 9.32198 9.44427L9.38735 9.46294ZM9.66218 9.18812L9.68246 9.25301L12.8805 8.25363L12.8602 8.18874L12.8399 8.12385L9.6419 9.12323L9.66218 9.18812ZM12.8602 8.18874L12.8806 8.2536C13.0447 8.20202 13.198 8.35608 13.1451 8.52438L13.21 8.54477L13.2748 8.56515C13.3593 8.29622 13.1129 8.03804 12.8398 8.12388L12.8602 8.18874Z",
    fill: "url(#paint3_linear_11877_11135)",
    mask: "url(#path-4-inside-1_11877_11135)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_11877_11135_clip_path",
    transform: "translate(0.209505 0.209505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4922 8.2461C14.4922 11.6958 11.6958 14.4922 8.2461 14.4922C4.79638 14.4922 2 11.6958 2 8.2461C2 4.797 4.79638 2 8.2461 2C11.6958 2 14.4922 4.797 14.4922 8.2461Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_11877_11135",
    x: 1.40508,
    y: 1.37383,
    width: 13.7328,
    height: 13.7328,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.44468,
    result: "effect1_foregroundBlur_11877_11135"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_11877_11135_clip_path",
    transform: "translate(-0.198258 -0.198747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6934 4.36279C14.19 4.36279 17.0244 7.19783 17.0244 10.6938C17.0244 14.1905 14.19 17.0249 10.6934 17.0249C7.19671 17.0249 4.3623 14.1905 4.3623 10.6938C4.36231 7.19783 7.1967 4.3628 10.6934 4.36279Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_11877_11135",
    x: 5.82508,
    y: 5.62586,
    width: 9.94798,
    height: 9.95432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.849809,
    dy: 0.849809
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.849809
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.447059 0 0 0 0 0.368627 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11877_11135"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11877_11135",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_11877_11135_clip_path",
    transform: "translate(-5.82508 -5.62586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.21 8.54477L12.1981 11.7428C12.1606 11.8739 12.0544 11.9801 11.9233 12.0182L8.73776 13.017C8.52539 13.0863 8.31927 12.8796 8.38797 12.6672L9.38735 9.46294C9.42483 9.33178 9.53101 9.23184 9.66218 9.18812L12.8602 8.18874C13.0788 8.12003 13.2787 8.32615 13.21 8.54477Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11877_11135",
    x1: 9.16577,
    y1: 9.08263,
    x2: 3.47314,
    y2: 11.8896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11877_11135",
    x1: 6.43582,
    y1: 5.90311,
    x2: 14.4045,
    y2: 15.7725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11877_11135",
    x1: 10.8562,
    y1: 9.02228,
    x2: 9.99371,
    y2: 12.7457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11877_11135",
    x1: 9.14643,
    y1: 8.74095,
    x2: 12.2444,
    y2: 12.5731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationCenter);
export default __webpack_public_path__ + "static/media/integrationCenter.24ea1407d881ccf3c52b22a29dae4308.svg";
export { ForwardRef as ReactComponent };